export default {
  id: null,
  nome: null,
  gedPastaPaiID: null,
  gedTipoID: null,
  gedAssuntoID: null,
  gedChecklistID: null,
  seguranca: false,
  status: null,
  gedPastas: null,
  gedPastaGrupos: null,
  gedPastaContas: null,
  gedPastaTags: null,
  tamanho: 0,
  contaAutorID: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/gedfoldermodel.js